export var TOTAL_INFO = [8, 9]; //can have 8 or 9 info in total according to lostAtticSpace
export var FINAL_STEP = '7';
export var ATTIC_SPACE_STEP = '6';
export var STEP_POSTAL_CODE_NEEDED = ['3'];
export var ENERGY_RENOVATION_DB_VERSION = 4;